import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

export const initialPaymentState = {
  firstParcel: 0,
  firstParcelBruto: 0,
  monthlyParcel: 0,
  couponFirstParcel: 0,
  insuranceFirstParcel: 0,
  insuranceMonthlyParcel: 0,
  paymentMethodSelected: "",
};

const usePaymentStore = create()(
  devtools(
    immer((set) => ({
      ...initialPaymentState,
      setPaymentStore(value, type) {
        set(
          (state) => {
            state[type] = value;
          },
          true,
          `setPaymentStore - ${type}`,
        );
      },
    })),
    { enabled: true, name: "usePaymentStore" },
  ),
);

export default usePaymentStore;
